import { ILicenseSelectOption } from "./types";

export const withoutTakenOptions = (
  options: ILicenseSelectOption[],
  takenValues: Array<string | null | undefined>,
  currentValue?: string | null,
) =>
  options.filter(
    (option) =>
      option.value === currentValue ||
      takenValues.every((taken) => taken !== option.value),
  );
